import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { CategoryType } from '@terminal/stores/use-history-sidebar-navigation/useHistorySidebarNavigation';

export const useChangeCategory = () => {
  const { setQueryParams } = useQueryParams();

  return (category: CategoryType) => {
    setQueryParams({ [queryKeys.activeHistorySidebarCategory]: category });
  };
};
